import dayjs from 'dayjs';
import { mediumOptions, statusOptions } from '../../../utils/constants';

export class PaginationRequest {
    constructor( props = {} ) {
        this.pageNumber = props.pageNumber || 1;
        this.pageSize = props.pageSize || 10;
        this.sortByOrder = props.sortByOrder || 'DESCENDING';
        this.sortByField = props.sortByField || 'DATE_SENT';
    }
}

export class PaginationResponse {
    constructor( props = {} ) {
        this.pageNumber = props.pageNumber || 1;
        this.pageSize = props.pageSize || 10;
        this.sortByOrder = props.sortByOrder || 'DESCENDING';
        this.sortByField = props.sortByField || 'DATE_SENT';
        this.totalElements = props.totalElements;
        this.totalPages = props.totalPages;
    }
}

export class NotificationListItem {
    constructor( props = {} ) {
        this.companyId = props.companyId;
        this.personId = props.personId;
        this.loginId = props.loginId;
        this.givenName = props.givenName;
        this.surname = props.surname;
        this.notificationInstanceId = props.notificationInstanceId;
        this.notificationInstanceDeliveryId = props.notificationInstanceDeliveryId;
        this.emailAddress = props.emailAddress;
        this.dateSent = props.dateSent
            ? dayjs( props.dateSent ).format( 'MM/DD/YYYY h:mm a' )
            : undefined;
        this.notification = props.notification
            ? new NotificationItem( props.notification )
            : undefined;
        this.status = props.status;
        this.medium = props.medium;
    }
}

export class NotificationItem {
    constructor( props = {} ) {
        this.id = props.id;
        this.name = props.name;
    }
}

export const initObserverState = {
    pageIsLoading: true,
    companyId: undefined,
    searchOptions: {
        programs: [],
        triggers: [],
        notifications: [],
        statuses: statusOptions,
        medium: mediumOptions
    },
    searchButtonsDisabled: true,
    notificationOptionsLoading: false,
    notificationsDisabled: true,
    searchValues: {},
    tableIsVisable: false,
    tableIsLoading: true,
    notificationList: [],
    paginationInfo: new PaginationResponse(),
    tableSort: { field: null, direction: null },
    downloadIsLoading: false,
    selectedNotifications: []
};

export const downloadCsvFile = data => {
    const blob = new Blob( [ data ], { type: 'text/csv' } );

    const a = document.createElement( 'a' );
    a.download = `notification-search-results-${ dayjs().format( 'MM-DD-YYYY' ) }.csv`;
    a.href = window.URL.createObjectURL( blob );
    const clickEvent = new MouseEvent( 'click', {
        view: window,
        bubbles: true,
        cancelable: true
    } );
    a.dispatchEvent( clickEvent );
    a.remove();
};

export const requestedOrder = order =>
    order === 'ascend' ? 'ASCENDING' : order === 'descend' ? 'DESCENDING' : null;

export const requestedField = field =>
    field === 'dateSent'
        ? 'DATE_SENT'
        : field === 'notification'
        ? 'NOTIFICATION_NAME'
        : field === 'status'
        ? 'STATUS'
        : field === 'medium'
        ? 'DELIVERY_MEDIUM'
        : undefined;
